import React, {useState, useEffect, useMemo, useCallback} from 'react';
import {myService} from '@app/services/sukienService';
import {alertService} from '@app/services/alertService';
import {useLocation} from 'react-router-dom';
import * as mainService from '@app/services/mainService';
import '../../../css/styles/custom-table.css'
import {Input, Tabs} from "@components";
import {getControllerName, getDefaultSelectValue,renewTrangthai} from '@app/utils/helpers';
import {
    image_root,
    INIT_ROLE_MENU,
    PAGES_SIZE_DEFAULT, SERVER_YYYYMM_FORMAT
} from '@app/const/AppSetting';
import HeaderClick from '@app/utils/HeaderClick';
import Pagination from "@material-ui/lab/Pagination";
import {useDispatch, useSelector} from "react-redux";
import {
    DownloadFile,
    findObjInArr,
    formatCurencyVI,
    formatDateClient,
    getFormData,
    getMenuName,
    isEmpty
} from "@app/utils/CommonFunctions";
import Select, { components } from "react-select";
import {useTranslation} from "react-i18next";
import {Card, HRTag} from "@components";
import {loadMenu} from "@store/reducers/auth";
import {Button, Modal} from "react-bootstrap";
import {saveAs} from 'file-saver';
import MyReactDatePicker from "@app/utils/MyReactDatePicker";
import {trangthaiSlice} from "@store/reducers/trangthaiSlice";
import CoquanListComponent from '@app/pages/FUtil/CoquanListComponent';
import TrangthaiListComponent from '@app/pages/FUtil/TrangthaiListComponent';
import NewDataButton from '@app/utils/NewDataButton';
import DaohuuAutocompleteComponent from '@app/pages/FUtil/DaohuuAutocompleteComponent';
import DaohuuLayoutComponent from '@app/pages/FUtil/DaohuuLayoutComponent';
import ImportErrorTable from '@app/pages/FUtil/ImportErrorTable';
import {ClipLoader} from "react-spinners";
import NhadanListComponent from "@pages/FUtil/NhadanListComponent";
import DaohuuchitietEditModal from './DaohuuchitietEditModal';
import {uploadService} from "@app/services/uploadService";
import dayjs from "dayjs";

const SukienDaohuuList = ({ history }) => {
    const [t] = useTranslation();
    const pageSizes = PAGES_SIZE_DEFAULT;
    const location = useLocation();
    const currController = getControllerName(location.pathname);
    const dispatch = useDispatch();
    const menu = useSelector((state) => state.auth.menu);
    const [roleMenu, setRoleMenu] = useState(INIT_ROLE_MENU);

    const initialSearchItems = {
        coquan_fk: null,
        ten: "",
        daohuuObj: null,
        nhadan_fk: null,
        trangthai_fk: null,
        searchbyText: ''
    };
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [importErrors, setImportErrors] = useState([]);
    const [importErrorsTitle, setImportErrorsTitle] = useState('');
    const [importcolumnError, setImportcolumnError] = useState('');

    const [removeToogle, setRemoveToogle] = useState(false);
    const [hasRole, setHasRole] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loadingTicket, setLoadingTicket] = useState(false);
    const [objs, setObjs] = useState([]);
    const [objAlls, setObjAlls] = useState([]);
    const [searchItems, setSearchItems] = useState({ ...initialSearchItems });
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [pageSize, setPageSize] = useState(pageSizes[2]);
    const [activeTab, setActiveTab] = useState(0);

    // Modal states
    const [showModal, setShowModal] = useState(false);
    const [selectedObj, setSelectedObj] = useState(null);
    const [parentId, setParentId] = useState('af3eefcde54966b433782ed770f1cf72');

    /// upload
    const [fileUpload, setFileUpload] = useState(null);

    // Memoized function to prevent unnecessary re-renders
    const storeSearchItems = useCallback((searchItems) => {
        const newMenu = menu.map((elem) => {
            return {
                ...elem,
                children: elem.children.map((item) =>
                    item.path.includes(currController) ? { ...item, searchItems: searchItems } : item,
                ),
            };
        });
        dispatch(loadMenu(newMenu));
    }, [menu, currController, dispatch]);

    // Debounced API call to prevent multiple calls
    const retrieveTutorials = useCallback(async (search) => {
        if (!search) search = searchItems;

        try {
            // Use daohuuchitiet API instead of generic getAll
            const { data, pageinfo } = await myService.getAllDaohuuchitiet(page, pageSize, search);
            setObjs(data);
            setObjAlls(data);
            setCount(pageinfo.totalpage);
        } catch (error) {
            console.error('Error retrieving daohuuchitiet:', error);
            alertService.error('Error loading data');
        }
    }, [page, pageSize, searchItems]);

    // Fixed filter change handler
    const onChangeFilter = useCallback(async (e) => {
        const { name, value } = e.target;
        const newSearch = { ...searchItems, [name]: value };

        setSearchItems(newSearch);

        // Only make API call for specific fields
        if (name === 'maChungTu') {
            await retrieveTutorials(newSearch);
        }

        // Store search items for date fields
        if (name === 'tuNgay' || name === 'denNgay') {
            storeSearchItems(newSearch);
        }
    }, [searchItems, retrieveTutorials, storeSearchItems]);

    // Simplified input change handler
    const onchangeInput = async (name, e) => {
        const { files} = e.target;
        setFileUpload(files[0]);
    }

    // Fixed selected change filter
    const onSelectedChangeFilter = useCallback(async (name, e) => {
        setLoadingTicket(true);

        try {
            const newSearch = { ...searchItems, [name]: e ? e.value : '' };
            setSearchItems(newSearch);
            storeSearchItems(newSearch);
            await retrieveTutorials(newSearch);
        } catch (error) {
            console.error('Error in filter change:', error);
        } finally {
            setLoadingTicket(false);
        }
    }, [searchItems, storeSearchItems, retrieveTutorials]);

    const createRs = useCallback(async () => {
        // Your existing createRs logic here if any
        // setLoading(false); // Don't set loading false here
    }, []);

    const loadTable = useCallback(async () => {
        setLoadingTicket(true);

        try {
            if (!hasRole) {
                const role = await mainService.getRoleMENU(location.pathname);
                setRoleMenu(role);
                setHasRole(true);
            }

            let search = {};
            menu.forEach((elem) => {
                const m = elem.children.find((item) => item.path.includes(currController));
                if (m !== undefined) search = m;
            });

            const searchData = search.searchItems || initialSearchItems;
            setSearchItems(searchData);
            await retrieveTutorials(searchData);

            let divtb1 = document.getElementById("divtb1");
            setActiveTab(divtb1 ? 0 : 1);
        } catch (error) {
            console.error('Error loading table:', error);
        } finally {
            setLoadingTicket(false);
        }
    }, [hasRole, location.pathname, menu, currController, initialSearchItems, retrieveTutorials]);

    // Fixed useEffect - initial load (simplified)
    useEffect(async () => {
        await mainService.checkRole({
            pathname: location.pathname,
            isAddMode: false,
            currController,
            history
        });
        console.log('currController:'+currController);
        await createRs();
        setLoading(false);
    }, []);

    // Fixed useEffect - data loading (simplified)
    useEffect(async () => {
        await createRs();
        await loadTable();
    }, [removeToogle, page, pageSize]);

    // Modal handlers
    const handleModalHide = () => {
        setShowModal(false);
        setSelectedObj(null);
        setParentId('af3eefcde54966b433782ed770f1cf72');
    };

    const handleModalSuccess = async () => {
        // Refresh the list after successful create/update
        await retrieveTutorials();
    };

    // Updated importClick function
    const importClick = async () => {
        if (!fileUpload) {
            alertService.error("Vui lòng chọn file");
            return;
        }

        setLoading(true);
        const form = getFormData({ fileUpload, uploadType: 'SUKIEN_DAOHUU_TYPE' });

        try {
            const result = await uploadService.ImportStandard(form);
            if (result) {
                if (result.status === "1") {
                    alertService.success(result.msg);
                    // Refresh the data after successful import
                    await retrieveTutorials();
                    // Clear the file input
                    setFileUpload(null);
                    const fileInput = document.getElementById('fileUpload');
                    if (fileInput) fileInput.value = '';
                } else {
                    // Show dynamic table with error data
                    setImportErrors(result.data || []);
                    setImportErrorsTitle(result.msg || 'Import thất bại')
                    setImportcolumnError(result.data2 || '')
                    setShowErrorModal(true);
                    alertService.error(result.msg || 'Import thất bại');
                }
            } else {
                alertService.error('Có lỗi xảy ra trong quá trình import');
            }
        } catch (error) {
            console.error('Import error:', error);
            alertService.error('Có lỗi xảy ra trong quá trình import');
        } finally {
            setLoading(false);
        }
    };

    const handleAddNew = () => {
        setSelectedObj(null); // null means new record
        setParentId('af3eefcde54966b433782ed770f1cf72'); // Set appropriate parent ID if needed
        setShowModal(true);
    };

    // Rest of your component methods remain the same...
    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }

    const findByTitle = async () => {
        setLoading(true);
        setPage(1);
        await retrieveTutorials();
        setLoading(false);
    };

    const removeSearch = async () => {
        setPage(1);
        setSearchItems({...initialSearchItems});
        setRemoveToogle((prevSelected) => !prevSelected);
    };

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (value.length > 0) {
            const filtered = objAlls.filter(
                item =>
                    (item.daohuuobj?.ten?.toLowerCase().indexOf(value.toLowerCase().trim()) > -1) ||
                    (item.nhom_su_kien?.toLowerCase().indexOf(value.toLowerCase().trim()) > -1) ||
                    item.id.toString().indexOf(value) > -1
            );
            setObjs(filtered);
        } else {
            setObjs(objAlls);
        }
    };

    const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
        setPage(1);
    };

    const editdonhang = (rowIndex) => {
        setSelectedObj({...objs[rowIndex]});
        setParentId('af3eefcde54966b433782ed770f1cf72'); // Set appropriate parent ID
        setShowModal(true);
    };

    const deletedonhang = async (rowIndex) => {
        const { id } = objs[rowIndex];
        try {
            const result = await myService.Delete_daohuuchitiet(id);
            if (result.status === "1") {
                alertService.success(t('fields.label.xoathanhcong'));
                await retrieveTutorials();
            } else {
                alertService.error(result.msg);
            }
        } catch (error) {
            alertService.error('Có lỗi xảy ra khi xóa dữ liệu');
        }
    };

    const excel = async () => {
        setLoading(true);
        try {
            const result = await myService.excelDaohuuchitiet(page, pageSize, searchItems);
            const blob = new Blob([result.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            saveAs(blob, roleMenu.tenmenu);
        } catch (error) {
            alertService.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    const excelPath = async (action) => {
        setLoading(true);
        try {
            const result = await myService.excelPathDaohuuchitiet({...searchItems, uploadType: action});
            if (result.status === "1") {
                await DownloadFile(image_root + result.data, result.data2);
            } else {
                alertService.error(result.msg);
            }
        } catch (error) {
            alertService.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    // Thay thế phần viewTable trong SukienDaohuuList:

    const viewTable = (
        loadingTicket ? (
            <div className="loading-state">
                <ClipLoader color="#3498db" size={50} />
            </div>
        ) : (
            <div className="card shadow-sm border-0">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            <thead className="custom-table-header">
                            <tr>
                                <th className="text-center" style={{ width: '14%' }}>Đạo hữu</th>
                                <th className="text-center" style={{ width: '10%' }}>Nhóm sự kiện</th>
                                <th className="text-center" style={{ width: '10%' }}>Phân loại sự kiện</th>
                                <th className="text-center" style={{ width: '7%' }}>Nhà đàn</th>
                                <th className="text-center" style={{ width: '7%' }}>Phận sự</th>
                                <th className="text-center" style={{ width: '9%' }}>Ngày thiên phong</th>
                                <th className="text-center" style={{ width: '9%' }}>Ngày sắc phong</th>
                                <th className="text-center" style={{ width: '7%' }}>Đốt sớ</th>
                                <th className="text-center" style={{ width: '7%' }}>Xin keo</th>
                                <th className="text-center" style={{ width: '7%' }}>Kết quả</th>
                                <th className="text-center" style={{ width: '13%' }}>Tác vụ</th>
                            </tr>
                            </thead>
                            <tbody>
                            {objs && objs.map((item, i) => {
                                let editable = [];

                                if (roleMenu.quyenchinhsua === 1) {
                                    editable.push(
                                        <button
                                            className="btn btn-warning btn-sm table-action-btn-small"
                                            key={`edit-${i}`}
                                            title={t('action.label.edit')}
                                            onClick={() => editdonhang(i)}
                                        >
                                            <i className="fas fa-pencil-alt"></i>
                                        </button>
                                    );
                                }

                                if (roleMenu.quyenxoa === 1) {
                                    editable.push(
                                        <button
                                            className="btn btn-danger btn-sm table-action-btn-small"
                                            key={`delete-${i}`}
                                            title={t('action.label.delete')}
                                            onClick={() => {
                                                if (window.confirm(t('fields.label.bancomuonxoa'))) {
                                                    deletedonhang(i);
                                                }
                                            }}
                                        >
                                            <i className="fas fa-trash"></i>
                                        </button>
                                    );
                                }

                                // Function để tạo badge với màu sắc phù hợp
                                const getBadgeClass = (value) => {
                                    if (!value) return 'badge bg-secondary text-white';

                                    const lowerValue = value.toLowerCase();
                                    if (lowerValue === 'được' || lowerValue === 'có') {
                                        return 'badge bg-success text-white';
                                    } else if (lowerValue === 'chưa' || lowerValue === 'không') {
                                        return 'badge bg-secondary text-white';
                                    } else {
                                        return 'badge bg-secondary text-white';
                                    }
                                };

                                return (
                                    item && (
                                        <tr key={`item-${i}`} className="custom-table-row">
                                            <td className="custom-table-cell">
                                                <DaohuuLayoutComponent currentSuggestion={JSON.parse(item.daohuuobj)} />
                                            </td>

                                            <td className="text-center custom-table-cell">
                                            <span className="badge bg-primary text-white" style={{ fontSize: '0.7rem' }}>
                                                {item.nhom_su_kien}
                                            </span>
                                            </td>

                                            <td className="text-center custom-table-cell">
                                            <span className="badge bg-info text-white" style={{ fontSize: '0.7rem' }}>
                                                {item.phan_loai_su_kien}
                                            </span>
                                            </td>

                                            <td className="text-center custom-table-cell">
                                                {(() => {
                                                    let badgeClass = 'badge text-white';
                                                    const nhadanLoai = item.nhadan_fk ? item.nhadan_fk : 0;

                                                    if (nhadanLoai === 1) {
                                                        badgeClass += ' bg-warning';
                                                    } else {
                                                        badgeClass += ' bg-secondary';
                                                    }

                                                    return (
                                                        <span className={badgeClass} style={{ fontSize: '0.7rem' }}>
                                                        {item.nha_dan}
                                                    </span>
                                                    );
                                                })()}
                                            </td>

                                            <td className="text-center custom-table-cell">
                                            <span className="fw-medium text-dark" style={{ fontSize: '0.8rem' }}>
                                                {item.phan_su}
                                            </span>
                                            </td>

                                            {/* Ngày thiên phong - từ ngay_su_kien_chi_tiet */}
                                            <td className="text-center custom-table-cell">
                                            <span className="fw-medium text-dark" style={{ fontSize: '0.8rem' }}>
                                                {item.ngay_su_kien_chi_tiet ? dayjs(item.ngay_su_kien_chi_tiet).format("DD/MM/YYYY") : '-'}
                                            </span>
                                            </td>

                                            {/* Ngày sắc phong - từ ngay_sac_phong */}
                                            <td className="text-center custom-table-cell">
                                            <span className="fw-medium text-dark" style={{ fontSize: '0.8rem' }}>
                                                {item.ngay_sac_phong ? dayjs(item.ngay_sac_phong).format("DD/MM/YYYY") : '-'}
                                            </span>
                                            </td>

                                            {/* Đốt sớ */}
                                            <td className="text-center custom-table-cell">
                                            <span className={getBadgeClass(item.trang_thai_dot_so)} style={{ fontSize: '0.7rem' }}>
                                                {item.trang_thai_dot_so || 'Chưa xác định'}
                                            </span>
                                            </td>

                                            {/* Xin keo */}
                                            <td className="text-center custom-table-cell">
                                            <span className={getBadgeClass(item.trang_thai_xin_keo)} style={{ fontSize: '0.7rem' }}>
                                                {item.trang_thai_xin_keo || 'Chưa xác định'}
                                            </span>
                                            </td>

                                            {/* Kết quả */}
                                            <td className="text-center custom-table-cell">
                                            <span className={getBadgeClass(item.trang_thai_ket_qua)} style={{ fontSize: '0.7rem' }}>
                                                {item.trang_thai_ket_qua || 'Chưa xác định'}
                                            </span>
                                            </td>

                                            <td className="text-center custom-table-cell">
                                                <div className="d-flex flex-wrap justify-content-center" style={{ gap: '3px' }}>
                                                    {editable}
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                );
                            })}
                            </tbody>
                        </table>
                    </div>

                    {(!objs || objs.length === 0) && (
                        <div className="empty-state">
                            <div className="text-muted mb-3">
                                <i className="fas fa-inbox fa-2x"></i>
                            </div>
                            <p className="text-muted">Không có dữ liệu để hiển thị</p>
                        </div>
                    )}
                </div>
            </div>
        )
    );

    return !loading && (
        <div className="card card-primary">
            <HeaderClick
                isIndex
                headerName={roleMenu.tenmenu}
                history={history}
                currController={currController}
            />
            <div className="card-body">
                <Card title={t('fields.label.boloctimkiem')} isDefaultActive>
                    <div className="card-body">
                        <div className="form-row small">
                            <div className="form-group-sm col-sm-2">
                                <TrangthaiListComponent
                                    trangthai_fk={searchItems.trangthai_fk}
                                    onChange={(e) => onSelectedChangeFilter('trangthai_fk', e)}
                                    filterIds={[0, 1]}
                                    trangthaiName="name"
                                />
                            </div>
                            <div className="form-group-sm col-sm-2">
                                <NhadanListComponent
                                    nhadan_fk={searchItems.nhadan_fk}
                                    onChange={(e) => onSelectedChangeFilter('nhadan_fk', e)}
                                />
                            </div>
                            <div className="form-group-sm col-sm-4">
                                <label>Đạo hữu</label>
                                <DaohuuAutocompleteComponent
                                    path_access={currController}
                                    currentSuggestion={searchItems.daohuuObj}
                                    onChange={(e) => onSelectedChangeFilter('daohuuObj', e)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-footer">
                        <button className="btn btn-dark mr-1" type="button" onClick={removeSearch}>
                            <i className="fa fa-undo"></i>
                        </button>
                        <Button type="button" className="btn btn-primary mr-1" onClick={excel}>
                            <i className="fa fa-file-excel"> Excel</i>
                        </Button>
                        {roleMenu.quyentaomoi === 1 && (
                            <Button type="button" className="btn btn-success mr-1" onClick={handleAddNew}>
                                <i className="fa fa-plus"> Thêm mới</i>
                            </Button>
                        )}
                        {roleMenu.quyentaomoi === 1 && (
                            <div className="row mt-2">
                                <div className="col-md-4">
                                    <label className="required" htmlFor="fileUpload">Import dữ liệu</label>
                                    <div className="input-group">
                                        <input
                                            id='fileUpload'
                                            name="fileUpload"
                                            type="file"
                                            className="form-control mr-1"
                                            onChange={(e) => onchangeInput('fileUpload', e)}
                                        />
                                        <Button
                                            type="button"
                                            className="btn btn-success"
                                            onClick={importClick}
                                        >
                                            <i className="fa fa-plus"></i> Upload
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Card>

                <HRTag title={t('fields.label.ketqua') + ' - ' + t('fields.label.list')}/>

                {viewTable}

                <div className="mt-3">
                    {t('footer.itemperpage')}
                    <select onChange={handlePageSizeChange} value={pageSize}>
                        {pageSizes.map((size) => (
                            <option key={size} value={size}>
                                {size}
                            </option>
                        ))}
                    </select>

                    <Pagination
                        className="my-3"
                        count={count}
                        page={page}
                        siblingCount={1}
                        boundaryCount={1}
                        variant="outlined"
                        shape="rounded"
                        onChange={handlePageChange}
                    />
                </div>
            </div>

            {/* DaohuuchitietEditModal Integration */}
            <DaohuuchitietEditModal
                showModal={showModal}
                initialObj={selectedObj}
                allowEdit={roleMenu.quyenchinhsua === 1}
                onHide={handleModalHide}
                onSuccess={handleModalSuccess}
                parentId={parentId}
            />
            <ImportErrorTable
                columnError={importcolumnError}
                show={showErrorModal}
                onHide={() => setShowErrorModal(false)}
                data={importErrors}
                title={importErrorsTitle}
                column
            />
        </div>
    );
};

export default SukienDaohuuList;